import React, { useCallback, useEffect, useMemo, useState } from 'react';

import { StyledTypography, VerticallyCenterContainer } from 'styles/common';

import { StyledIcon, TaskTypeIcon } from 'constants/icons';

import AntSwitch from 'uiToolkit/AntSwitch';

import { getSelectedFiltersCountFromMap } from './helper';
import { ItemContainer } from './styles';

export const TASK_TYPE_FILTER_SELECT = 'TASK_TYPE_FILTER_SELECT';
export const TASK_TYPE_FILTER_UPDATE = 'TASK_TYPE_FILTER_UPDATE';

export const intialTaskTypeFilters = { SUB_TASK: true };

export function taskTypeFilterReducer(state = {}, action) {
  switch (action.type) {
    case TASK_TYPE_FILTER_SELECT: {
      const newState = { ...state };
      newState[action.value] = !newState[action.value];
      return newState;
    }
    case TASK_TYPE_FILTER_UPDATE: {
      return { ...action.values };
    }
    default:
      return state;
  }
}

export function buildTaskTypeFilters(selectedTaskTypes) {
  const ids = Object.entries(selectedTaskTypes).reduce((ids, [taskTypeId, isSelected]) => {
    if (isSelected) ids.push(taskTypeId);
    return ids;
  }, []);
  if (ids.includes('SUB_TASK')) {
    return ['SUB_TASK', 'TASK'].map((id) => ({ type: 'TASK_TYPE', value: id, operator: 'IN' }));
  }
  return [{ type: 'TASK_TYPE', value: 'TASK', operator: 'IN' }];
}

export default function TaskTypeFilter({ dispatch, selectedFilters, taskTypes, width = '18%', isDisabled = false }) {
  const [selected, setSelected] = useState({ SUB_TASK: true, TASK: true });

  const filterIds = useMemo(
    () =>
      Object.entries(selectedFilters).reduce((ids, [value, isSelected]) => {
        isSelected && ids.push(value);
        return ids;
      }, []),
    [selectedFilters]
  );

  function onSelect(value) {
    dispatch({ type: TASK_TYPE_FILTER_UPDATE, values: { ...selected, [value]: !selected[value] } });
    setSelected((selected) => ({ ...selected, [value]: !selected[value] }));
  }

  const makeCurrentStateEqualToSelectedState = useCallback(() => {
    const selected = {};
    filterIds.forEach((id) => (selected[id] = true));
    setSelected(selected);
  }, [filterIds]);

  useEffect(() => {
    makeCurrentStateEqualToSelectedState();
  }, [selectedFilters]);

  // useEffect(() => {
  // }, [selected]);

  // function onApply() {
  //   dispatch({ type: TASK_TYPE_FILTER_UPDATE, values: { ...selected } });
  //   document.body.click();
  // }

  const selectedCount = getSelectedFiltersCountFromMap(selectedFilters);
  return (
    // <CustomMenu
    //   icon={
    //   }
    //   onOpen={makeCurrentStateEqualToSelectedState}
    // >
    // </CustomMenu>
    <ItemContainer
      width={width}
      justify="space-between"
      onClick={() => {
        onSelect(taskTypes[0].value);
        // onApply();
      }}
      disabled={!taskTypes.length}
      style={{ paddingLeft: '1.5rem', paddingRight: '1.5rem', border: '1px solid #eaeaea' }}
    >
      <VerticallyCenterContainer container alignItems="center">
        <StyledIcon color="textSecondary" size="tiny">
          <TaskTypeIcon />
        </StyledIcon>
        <StyledTypography leftGutter={1} display="inline">
          Show Task
        </StyledTypography>
      </VerticallyCenterContainer>
      <VerticallyCenterContainer container alignItems="center">
        <AntSwitch checked={selected.SUB_TASK} />
      </VerticallyCenterContainer>
    </ItemContainer>
    /* <DropdownList>
        <ScrollableContainer>
          {taskTypes.map(taskType => (
            <MenuItem onClick={onSelect.bind(null, taskType.value)}>
              <Checkbox checked={Boolean(selected[taskType.value])} color="primary" />
              <StyledTypography display="inline">{taskType.label}</StyledTypography>
            </MenuItem>
          ))}
        </ScrollableContainer>
        <ApplyMenuItem onClick={onApply}>
          <StyledTypography color="primary">Apply</StyledTypography>
        </ApplyMenuItem>
      </DropdownList> */
  );
}
